import { render, staticRenderFns } from "./tz.vue?vue&type=template&id=07788d64&scoped=true"
import script from "./tz.vue?vue&type=script&lang=js"
export * from "./tz.vue?vue&type=script&lang=js"
import style0 from "./tz.vue?vue&type=style&index=0&id=07788d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07788d64",
  null
  
)

export default component.exports